import React from 'react'
import Header from '../../components/Header'
import {
    Link
} from "react-router-dom";
import Icon from '../../ui/Icon';
import DataTable from "../../components/DataTable";
import resources from "../../api";
import config from '../../constants';
import { Button, ButtonGroup } from '@chakra-ui/react'
import {
    FiPlusCircle
} from 'react-icons/fi';

export default function index() {
    return (
        <div>

            <div className="row">
                <div className="col">
                    <h3 className='mt-3'>Bin location</h3>
                    <div className="d-flex justify-content-between">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">

                                <li className="breadcrumb-item active" aria-current="page">Bin location</li>
                            </ol>
                        </nav>
                        <Link className="btn btn-app-default" to="/bin/create"> <Button leftIcon={<FiPlusCircle />} colorScheme='brand'>New</Button></Link>
                    </div>

                    <DataTable column={[

                        { label: "Name", field: "name" },
                        { label: "Description", field: "description" }
                    ]}

                        filterOption={false}
                        filterLoader={() => { }}
                        element={"bin"}
                        resource={resources.bin}
                        action={(data) => {

                        }}
                        deleteItem
                        update
                    />
                </div>
            </div>

        </div>
    )
}
